// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_nTbvQ {
  width: 220px; 
  background-color: var(--white-background); 
  padding: 25px 0; 
  border-right: 1px solid #e8e8e8; 
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
}

.sidebar_nTbvQ.collapsed_mbJVJ {
  width: 60px;
  overflow: hidden;
}

.toggleButton_K__S5 {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f0f2f5;
  color: #555;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  z-index: 5;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
}

.toggleButton_K__S5:hover {
  background-color: #e6f7ff;
  color: #00a3a3;
}

.sidebar_nTbvQ nav {
  flex-grow: 1;
}

.sidebar_nTbvQ nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menuItem_HyR3C {
  padding: 10px 20px 10px 25px; 
  margin-bottom: 5px; 
  cursor: pointer;
  font-size: 0.9rem;
  color: #555;
  border-left: 4px solid transparent; 
  transition: background-color 0.2s ease, color 0.2s ease,
    border-left-color 0.2s ease;
  position: relative; 
}

.menuItem_HyR3C:hover {
  background-color: #f7f7f7; 
  color: #333;
}

.menuItem_HyR3C.active_Q_p5Y {
  background-color: #e6f7ff; 
  color: #00a3a3; 
  font-weight: 600;
  border-left-color: #00a3a3; 
}

.collapsed_mbJVJ .menuItem_HyR3C {
  padding: 10px;
  text-align: center;
  white-space: nowrap;
}

.collapsed_mbJVJ .menuItem_HyR3C::before {
  content: attr(data-initial);
  display: block;
  font-size: 16px;
}

.collapsed_mbJVJ nav ul li span {
  opacity: 0;
}

.menuItem_HyR3C.active_Q_p5Y::before {
  content: '';
  position: absolute;
  left: 0;
  top: -10px; 
  width: 4px;
  height: 10px;
}
.menuItem_HyR3C.active_Q_p5Y::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px; 
  width: 4px;
  height: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC;+BAC6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,UAAU;EACV,YAAY;AACd","sourcesContent":[".sidebar {\n  width: 220px; \n  background-color: var(--white-background); \n  padding: 25px 0; \n  border-right: 1px solid #e8e8e8; \n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transition: width 0.3s ease;\n}\n\n.sidebar.collapsed {\n  width: 60px;\n  overflow: hidden;\n}\n\n.toggleButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #f0f2f5;\n  color: #555;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  cursor: pointer;\n  z-index: 5;\n  border: 1px solid #e8e8e8;\n  transition: all 0.2s ease;\n}\n\n.toggleButton:hover {\n  background-color: #e6f7ff;\n  color: #00a3a3;\n}\n\n.sidebar nav {\n  flex-grow: 1;\n}\n\n.sidebar nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menuItem {\n  padding: 10px 20px 10px 25px; \n  margin-bottom: 5px; \n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #555;\n  border-left: 4px solid transparent; \n  transition: background-color 0.2s ease, color 0.2s ease,\n    border-left-color 0.2s ease;\n  position: relative; \n}\n\n.menuItem:hover {\n  background-color: #f7f7f7; \n  color: #333;\n}\n\n.menuItem.active {\n  background-color: #e6f7ff; \n  color: #00a3a3; \n  font-weight: 600;\n  border-left-color: #00a3a3; \n}\n\n.collapsed .menuItem {\n  padding: 10px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.collapsed .menuItem::before {\n  content: attr(data-initial);\n  display: block;\n  font-size: 16px;\n}\n\n.collapsed nav ul li span {\n  opacity: 0;\n}\n\n.menuItem.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -10px; \n  width: 4px;\n  height: 10px;\n}\n.menuItem.active::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -10px; \n  width: 4px;\n  height: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sidebar_nTbvQ`,
	"collapsed": `collapsed_mbJVJ`,
	"toggleButton": `toggleButton_K__S5`,
	"menuItem": `menuItem_HyR3C`,
	"active": `active_Q_p5Y`
};
export default ___CSS_LOADER_EXPORT___;
